<template>
  <div>
    <detailbox :title="'帮助中心'" :info="info.site_help"></detailbox>
    <div class="bar"></div>
  </div>
</template>

<script>
  import detailbox from '@/components/common/detailbox/detailbox'
  import { configResource } from '@/resource/resource'
  import {mapState, mapMutations} from 'vuex'
  const ERR_OK = 0
  export default {
    name: 'helpcenter',
    data () {
      return {
        info: ''
      }
    },
    computed: {
      ...mapState(['config_info'])
    },
    created () {
      this.scroll()
      if (!this.config_info.help) {
        this.getConfig()
      } else {
        this.info = this.config_info.help
      }
    },
    mounted () {
    },
    methods: {
      scroll () {
        setTimeout(() => {
          this.$emit('bscroll')
        }, 20)
      },
      getConfig () {
        configResource.config({ config: 'site_help' }).then(response => {
          response = response.body
            if (response.errcode === ERR_OK) {
              this.config_info.help = response.data
              this.info = response.data
            }
        })
      },
        // 更新vuex状态信息
      ...mapMutations([
        'CONFIG_INFO'
      ])
    },
    components: {
      detailbox
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .bar
    height 0.2rem
    width 100%
</style>



// WEBPACK FOOTER //
// src/components/helpcenter/helpcenter.vue